<template type="text/template" id="template_pagination">
  <section class="pages-wrap" v-show="pageInfo.total > 0">
    <ul class="Pagination clearfix">
      <li :class="{'disabled': pageInfo.current == 1}"><a :href=" noPage || fullpath + (pageInfo.current !==1 ? pageInfo.current - 1 : 1)" @click.prevent="clickCurrent(pageInfo.current - 1)"><img :src="imgPrefix + 'static/icon-left.png'" /></a></li>
      <li v-for="p in setList" :class="{'active': pageInfo.current == p.val}">
        <a :href="noPage || fullpath + p.val" v-if="pageInfo.current == p.val" @click.prevent="clickCurrent(p.val)"> {{ p.text }} </a>
        <a :href="noPage || fullpath + p.val" v-else @click.prevent="clickCurrent(p.val)"> {{ p.text }} </a>
      </li>
      <li :class="{'disabled': pageInfo.current === page}"><a :href="noPage || fullpath + (pageInfo.current + 1)" @click.prevent="clickCurrent(pageInfo.current + 1)"><img :src="imgPrefix + 'static/icon-right.png'" /></a></li>
    </ul>
  </section>
</template>

<script>
  export default {
    data() {
      return {
        imgPrefix: process.env.PREFIX_IMG,
      }
    },
    props: {
      pageInfo: {
        type: Object,
        default: {}
      },
      noPage: {
        type: String,
        default: 'javascript:;'
      }
    },
    computed: {
      page: function () {
//        if (this.$store.state.product.FilterList.over_count) {
//          return Math.ceil((this.pageInfo.total-this.$store.state.product.FilterList.over_count) / this.pageInfo.pagenum);
//        } else {
          return Math.ceil(this.pageInfo.total / this.pageInfo.pagenum);
//        }
      },
      setList: function () {
        var len = this.page, temp = [], list = [], count = Math.floor(this.pageInfo.pagegroup / 2), center = this.pageInfo.current;
        if (len <= this.pageInfo.pagegroup) {
          while (len--) { temp.push({ text: this.page - len, val: this.page - len }); };
          return temp;
        }
        while (len--) { temp.push(this.page - len); };
        var idx = temp.indexOf(center);
        (idx < count) && (center = center + count - idx);
        (this.pageInfo.current > this.page - count) && (center = this.page - count);
        if(this.page>this.pageInfo.pagegroup && this.page-this.pageInfo.current<=count){
            temp = temp.splice(center - count, this.pageInfo.pagegroup);
        }else{
          temp = temp.splice(center - count-1, this.pageInfo.pagegroup);
        }
        do {
          var t = temp.shift();
          list.push({
            text: t,
            val: t
          });
        } while (temp.length);
        if (this.page > this.pageInfo.pagegroup) {
          (this.pageInfo.current > count + 1) && list.unshift({ text: '...', val: list[0].val - 1 });
          (this.pageInfo.current < this.page - count) && list.push({ text: '...', val: list[list.length - 1].val + 1 });
        }
        return list;
      },
      fullpath() {
        let route = this.$route.fullPath;
        return route.indexOf('?') !== -1 ? route + '&page=' : route + '?page=';
      }
    },
    created: function (argument) {
    },
    methods: {
      clickCurrent: function (idx) {
        $('html,body').animate({ scrollTop: 0 }, 100);
        if (this.pageInfo.current != idx && idx > 0 && idx < this.page + 1) {
          if (this.noPage === '') {
            let query = Object.assign({}, this.$route.query, {
              page: idx
            });
            this.$router.push({ query: query });
          }
          this.pageInfo.current = idx;
          this.$emit('change', this.pageInfo.current);
        }
      }
    }
  }

</script>
<style type="text/css" scoped>
  .pages-wrap {
    text-align: center;
    margin: 35px 0;
    margin-bottom: 0;
    padding-bottom: 40px;
  }
  .Pagination {
    display: inline-block;
  }
  .Pagination li {
    float: left;
    margin-right: 10px;
  }
  .Pagination li a {
    display: block;
    padding: 10px 18px;
    background-color: #fff;
    text-decoration: none;
	color: #333;
  }
  .Pagination li .icon-right,
  .Pagination li .icon-left {
    font-weight: 600;
    color: #666666;
    padding: 10px 14px;
  }
  .Pagination li:hover a {
    color: #fff;
    background-color: #00a0e9;
  }
  .Pagination .active a {
    color: #fff !important;
    background-color: #00a0e9 !important;
  }
  .Pagination .disabled a:hover {
    color: #000;
    cursor: not-allowed;
    background-color: #fff;
  }
  @media (max-width: 1024px) {
    .Pagination li:hover a {
      color: #000;
      background: #fff;
    }
  }
  @media (max-width: 767px) {
    .Pagination li a {
      padding: 3px 12px;
    }
	.Pagination li img{
		width: 12px;
	}
    .Pagination li .icon-right,
    .Pagination li .icon-left {
      padding: 10px 5px;
    }
    .Pagination li .icon-right {
      margin-right: 0;
    }
	.paging{
		margin-bottom: 0 !important;
	}
  }
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue